import React from 'react';

interface WorkspaceSectionGroupProps {
  children: React.ReactNode;
}

/**
 * Casca única do bloco de pendências de um perfil: recebe várias `WorkspaceSection`
 * como filhas e insere automaticamente o divisor cinza espesso entre elas — sem
 * precisar de lógica "primeiro item não tem borda" em cada chamada.
 */
const WorkspaceSectionGroup: React.FC<WorkspaceSectionGroupProps> = ({ children }) => (
  <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-950 [&>*+*]:border-t-8 [&>*+*]:border-slate-100 dark:[&>*+*]:border-slate-800">
    {children}
  </div>
);

export default WorkspaceSectionGroup;
